import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateBranchErrorsMapper, CreateBranchMapper } from '../mappers';
import { CreateBranchDto } from '../dtos';

export type ICreateBranchRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreateBranchRepo = IRepo<[CreateBranchDto, string | number | undefined], ICreateBranchRepoResponse>;

export const CreateBranchRepoType = Symbol.for('CreateBranchRepo');

@bind(CreateBranchRepoType)
export class CreateBranchRepo implements ICreateBranchRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateBranchDto, id?: string | number) {
    try {
      const body = new FormData();
      const mappedBody = CreateBranchMapper.toPersistence(dto);
      appendToFormData(mappedBody, body);

      const url = id ? urlMaker('/api/admin/branches/edit') : urlMaker('/api/admin/branches/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreateBranchErrorsMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
